<template>
  <v-dialog v-model="showDialog" :max-width="800" :persistent="loading">
    <v-card class="pa-0">
      <div class="text-right d-flex text-white bg-black pa-2">
        <div class="text-left pa-0">
          {{ title }}
        </div>
        <v-icon
          class="ml-auto"
          size="20"
          color="#fff"
          :disabled="loading"
          @click="showDialog = false"
          >mdi-close-circle</v-icon
        >
      </div>
      <v-simple-table dense class="pa-2">
        <template #default>
          <thead class="custom-table-bordered">
            <tr>
              <td class="text-center bg-gray" colspan="6">
                <b>{{ subTitle }}</b>
              </td>
            </tr>
          </thead>
          <tbody v-if="!loading" class="custom-table-bordered text-body">
            <tr class="bg-gray">
              <td>Mes</td>
              <td>Presupuesto</td>
              <td>Facturación</td>
              <td>Porcentaje</td>
              <td>Diferencia</td>
            </tr>
            <tr
              v-for="(item, index) in data.detail"
              :key="index"
              class="small"
              :class="{ 'bg-gray': index % 2 == 0 }"
            >
              <td>{{ item.MES }}</td>
              <td>{{ formatNumber(item.PRESUPUESTO, '$', 0) }}</td>
              <td>{{ formatNumber(item.FACTURACION, '$', 0) }}</td>
              <td>{{ formatNumber(item.AVPTOFACPER, '', 2) }}%</td>
              <td>{{ formatNumber(item.DIFERENCIA, '$', 0) }}</td>
            </tr>
            <tr class="font-weight-bold">
              <td>Total</td>
              <td>{{ formatNumber(data.sumEstimate, '$', 0) }}</td>
              <td>{{ formatNumber(data.sumBilling, '$', 0) }}</td>
              <td>{{ formatNumber(data.growth, '', 2) }}%</td>
              <td>{{ formatNumber(data.sumDifference, '$', 0) }}</td>
            </tr>
          </tbody>
          <tbody v-if="loading">
            <tr>
              <td colspan="7">
                <v-progress-linear class="mt-3" indeterminate color="teal" />
                <span class="text--disabled"> Cargando información</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-btn class="ma-2" :disabled="loading" @click="showDialog = false"
        >Cerrar</v-btn
      >
    </v-card>
  </v-dialog>
</template>
<script>
  import numbersFormats from '@/mixins/numbersFormats';

  export default {
    name: 'BillingVsEstimate',
    mixins: [numbersFormats],
    props: {
      title: {
        type: String,
        default: 'Detalle de facturación VS PPTO acumulado',
      },
      subTitle: {
        type: String,
        default: 'Presupuesto / Facturación actual',
      },
      value: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: true,
      },
      data: {
        type: Object,
        default: () => ({
          items: [],
          totals: {},
        }),
      },
    },
    computed: {
      showDialog: {
        set(value) {
          this.$emit('input', value);
        },
        get() {
          return this.value;
        },
      },
    },
  };
</script>
